import React from 'react';
import {
	Navbar,
	NavbarBrand,
	Nav,
	NavItem,
	NavLink,
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Categories from '../assets/data/Category.json';
function MenuHeader() {
	const { allCategories } = useSelector(state => state.category);

	return (
		<>
			<Navbar
				className='px-5'
				className='menu_header justify-content-start d-none d-md-flex'
				light
			>
				<Nav navbar className='flex-row ml-4'>
					<NavItem className='mx-3'>
						<NavLink href='/'>Home</NavLink>
					</NavItem>
					<UncontrolledDropdown nav>
						<DropdownToggle
							nav
							caret
							className='text-white font-weight-bold'
						>
							Products Category
						</DropdownToggle>
						<DropdownMenu right>
							{allCategories.map(d => {
								return (
									<Link
										to={{
											pathname: `/shop`,
											search: d.categoryName,
										}}
									>
										<DropdownItem>
											{d.categoryName}
										</DropdownItem>
									</Link>
								);
							})}
						</DropdownMenu>
					</UncontrolledDropdown>

					<NavItem className='mx-3'>
						<NavLink href='/shop'>Shop</NavLink>
					</NavItem>
					<NavItem className='mx-3'>
						<NavLink href='/blog'>Blog</NavLink>
					</NavItem>
					<NavItem className='mx-3'>
						<NavLink href='/faqs'>FAQs</NavLink>
					</NavItem>
					<NavItem className='mx-3'>
						<NavLink>Contact</NavLink>
					</NavItem>
					{/* <NavItem className='mx-3'>
						<NavLink>About Us</NavLink>
					</NavItem> */}
					<NavItem className='margin__class d-none d-xl-block'>
						<NavLink className='ml-auto float-right ms-auto mx-auto'>
							Need help? <i className='fa fa-phone'></i> 0020 -
							500 - 000
						</NavLink>
					</NavItem>
				</Nav>
				{/* <Nav navbar className='ml-auto'>
					<NavItem>
						<NavLink>
							Need help? <i className='fa fa-phone'></i> 0020 -
							500 - 000
						</NavLink>
					</NavItem>
				</Nav> */}
			</Navbar>
		</>
	);
}

export default MenuHeader;
